import { OrderDetailsResponse } from '..';
import { getLabelsByLanguage } from '../../../../../utilites/util';

interface TransactionDetailsProps {
  data: OrderDetailsResponse;
}

const TransactionOverviewDetails: React.FC<TransactionDetailsProps> = ({ data }) => {
  const {
    transactionDetails,
    customerData,
    orderContent,
    transactionData,
    sellerData,
    email,
    transactionType,
    transactionNumber,
    amount,
    phoneNumber,
    naming,
    address,
    companyNumber,
    cardType,
    transactionId,
    approvalTime,
    approvalNumber,
    ipAddress,
    transactionTypeTopup,
  } = getLabelsByLanguage();

  return (
    <div className="topup-transaction-overview">
      <h3 className="yettel-bold-font text-20 mb-4">{transactionDetails}</h3>
      <div className="topup-transaction-overview__details">
        <section>
          <h4 className="yettel-bold-font text-18 mb-4">{customerData}</h4>
          <p>
            {email}: {data.cardholderEmail ?? data.email}
          </p>

          <h4 className="yettel-bold-font text-18 mb-4 mt-4">{orderContent}</h4>
          <p>
            {transactionType}: {transactionTypeTopup}
          </p>
          <p>
            {phoneNumber}: {data.phoneNumber}
          </p>
          <p>
            {amount}: {data.transactionAmount / 100} RSD
          </p>
        </section>

        <section>
          <h4 className="yettel-bold-font text-18 mb-4">{transactionData}</h4>
          <p>
            {transactionNumber}: {data.orderNumber}
          </p>
          <p>
            {cardType}: {data.ccType}
          </p>
          <p>
            {transactionId}: {data.referenceNumber}
          </p>
          <p>
            {approvalNumber}: {data.approvalCode}
          </p>
          <p>
            {ipAddress}: {data.ipAddress}
          </p>
          <p>
            {approvalTime}: {data.transactionDateAndTime}
          </p>
          <p>
            {amount}: {data.transactionAmount / 100} RSD
          </p>
        </section>

        <section>
          <h4 className="yettel-bold-font text-18 mb-4">{sellerData}</h4>
          <p>{naming}: Yettel</p>
          <p>{address}: 11070 Beograd,</p>
          <p>Omladinskih brigada 90</p>
          <p>{companyNumber}: 20147229</p>
          <p>PIB: 104318304</p>
        </section>
      </div>
    </div>
  );
};

export default TransactionOverviewDetails;
